import { CRS } from "./CRS";
import std from "url:../../../assets/cursors/DefaultCursor.png";

export function STD () {
    return <CRS>
        <img src={std} className='mcs-icon' />
    </CRS>
}